<template>
<div>

    <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>
            <nav class="admin breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li><router-link tag="a" :to="{name: 'admin'}">Admin</router-link></li>
                <li><router-link tag="a" :to="{name: 'admin-blogs'}">Blogs</router-link></li>
                <li class="is-active"><a href="#">Edit blog</a></li>
              </ul>
            </nav>
                Edit blog
            </h1>
        </div>
      </section>
    </div>

    <div class="section">

        <div class="container">
          <h2 class="title">
            {{item.title}} 
            <router-link tag="a" :to="{name: 'blog', params: {slug: item.slug}}" class="button is-text" target="_blank" :class="{disabled: !item.slug}">View</router-link>
            </h2>

          <form class="edit-form" id="edit-form" v-model="valid" ref="form" lazy-validation v-on:submit.prevent>
            
            <div class="columns">
                <div class="column main is-two-thirds">

                    <input type="hidden" name="_token" value="arhghgjuythf" />
                    <input type="hidden" name="_username" v-model="username" v-validate="'required'">

                    <div class="field">
                        <label class="label">Title *</label>
                        <div class="control">
                          <input name="title" v-model.trim="item.title" v-validate="'required|min:3'" v-bind:class="{'is-danger': errors.has('title')}" class="input" type="text" placeholder="Name of blog">
                        </div>
                        <p class="help is-danger" v-show="errors.has('title')">
                          {{ errors.first('title') }}
                        </p>
                    </div>

                    <div v-if="item.title">
                        <div class="field group-block">
                            <label class="label">Url * <span class="has-text-weight-normal">(must be lowercase letters/numbers; and use dashes instead of spaces)</span></label>
                            <div class="control">
                              <!-- <input :disabled="!editSlug && !isNewlycreatedblog" name="slug" v-model.trim="makeslug" v-validate="'required|min:3|alpha_dash'" v-bind:class="{'is-danger': errors.has('slug')}" class="input" type="text" placeholder="Url of blog, which should be similar to the Title e.g. the-tempest"> -->
                              <input :disabled="!editSlug" name="slug" v-model.trim="makeslug" v-validate="'required|min:3|alpha_dash'" v-bind:class="{'is-danger': errors.has('slug')}" class="input" type="text" placeholder="Url of blog, which should be similar to the Title e.g. the-tempest">
                            </div>
                            <p class="help is-danger" v-show="errors.has('slug')">
                              {{ errors.first('slug') }}
                            </p>
                          <!-- <div class="control" v-if="!isNewlycreatedblog"> -->
                          <div class="control">
                            <button class="button is-text" @click="editSlug = !editSlug">Edit url</button>
                          </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Main Image *</label>
                        <div>
                            <FileUpload type="blogs" :playId="item._id" :item="item" imageKey="mainimage" index="" v-if="item._id" />
                        </div>
                    </div>
                    
                    <div class="field">
                        <label class="label">Body *</label>
                        <div class="control">
                          <vue-editor name="body" v-model="item.body" v-validate="'min:3'" v-bind:class="{'is-danger': errors.has('body')}"></vue-editor>
                          <!-- <textarea rows="14" name="body" class="textarea" v-validate="'min:3'" placeholder="Summary of the blog, disbloged on Homepage, etc." v-bind:class="{'is-danger': errors.has('body')}" v-model="item.body"></textarea> -->
                        </div>
                        <p class="help is-danger" v-show="errors.has('body')">
                          {{ errors.first('body') }}
                        </p>
                    </div>

                    <div class="field">
                        <label class="label">Photos</label>
                        <div class="field group-block" v-for="(image, index) in item.images" :key="image._id">
                            <!-- <div class="control">
                              <a :href="'/images/blogs/' + image.url" target="_blank" title="Open image in another tab"><img :src="'/images/blogs/' + image.url" name="photo" v-model="image.url" v-validate="'required'" v-bind:class="{'is-danger': errors.has('photo')}" alt="Photo from photoshoot" /></a>
                            </div> -->

                            <FileUpload type="blogs" :blogId="item._id" :item="image" imageKey="photo" :index="index" v-if="item._id" /> 
                        </div>
                        <div class="field">
                          <div class="control">
                            <button class="button is-text" @click="item.images.push({})">+ Add photo</button>
                          </div>
                        </div>
                    </div>

                    <section class="section">
                        <div class="field is-grouped">
                          <div class="control">
                            <!-- <button @click="submit" :disabled="!valid">Save changes</button> -->
                            <button class="button is-primary" v-bind:disabled="errors.any()" @click="submit">Save changes</button>
                          </div>
                          <div class="control">
                            <button class="button is-text" id="cancel" @click="cancel">Close</button>      
                          </div>
                        </div>
                    </section>
                    <span class="has-text-weight-normal">Last edited by {{ item.updatedBy }}</span>

                </div>




                <aside class="column sidebar">
                    
                    <div class="field">
                      <label class="label">Author *</label>
                       <div class="control">
                          <input name="author" v-model.trim="item.author" v-validate="'required|min:3'" v-bind:class="{'is-danger': errors.has('author')}" class="input" type="text" placeholder="Name of the person that wrote this blog">
                        </div>
                        <p class="help is-danger" v-show="errors.has('author')">
                          {{ errors.first('author') }}
                        </p>
                    </div>   


                    <div>
                        <div class="title">Date</div>
                        <div class="field">
                            <label class="label">Display date</label>
                            <div class="control">
                                <datepicker v-model="item.order" name="displaydate" v-bind:class="{'is-danger': errors.has('displaydate')}"  type="text" input-class="datepicker" placeholder="Date when the blog was written"></datepicker>
                            </div>
                            <p class="help is-danger" v-show="errors.has('displaydate')">
                              {{ errors.first('displaydate') }}
                            </p>
                        </div>
                    </div>
 

                </aside>
            </div>

          </form>
            

          <ul class="navbar-nav ml-auto">
              <!-- <li class="nav-item active" v-for="item in item.blogs" :key="item._id">
                  <router-link tag="a" :to="{name: 'adminBlog', params: {item: item}}" class="nav-link" target="_blank">Edit </router-link>
                  <router-link tag="a" :to="{name: 'blog', params: {slug: item.slug}}" class="nav-link" target="_blank">View </router-link>
                  {{ item.title }}
              </li> -->
          </ul>

        </div>

        
    </div>

</div>
</template>

<script>
import Api from '@/config/Api'
import { mapGetters, mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import { VueEditor } from 'vue2-editor' //for HTML WYSIWYG editor




//import ProductGroupCards from '../cards/ProductGroupCards';
//import ProductCards from '../cards/ProductCards';
import FileUpload from '../FileUpload';

export default {
    //name: 'adminBlog',
    props: ['slug'],
    data() {
        return {
            item: {
                slug: 'temp',
                mainimage: '',
                images: [ {photo: ''} ],
                auditionEmailRecipient: ''
            },
            error: false,
            valid: true,
            editSlug: false,
            originalSlug: '',
            isNewlycreatedblog: false
        }
    },
    components: {
        //ProductGroupCards,
        //ProductCards,
        FileUpload,
        Datepicker,
        VueEditor
    },
    computed: {
        ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
        ...mapState({
          authLoading: state => state.status === 'loading',
          name: state => `${state.user.profile.name}`, 
        }),
        username() {
            var n = this.name;
            if (n == 'undefined') n = "not logged in";
            return n;
        },
        makeslug() {
          var slug = this.sanitizeTitle(this.item.title);
          this.item.slug = slug;
          return slug;
          /* get() {
            if (this.item.slug != this.sanitizeTitle(this.item.title)) {
                console.log("h1");
                return this.item.slug;
            }
            console.log("h2");
            return this.sanitizeTitle(this.item.title);
          },
          set(value) { 
            this.slugoverride = true;
            this.item.slug = value; 
          }, */
        }
        /* startdate() {
            var d = this.item.dates;
            if (!d) return;
            return d.startdate;
        } */
    },    
    created() {
        Api().get(`/api/blogs/${this.slug}`).then(response => {
            this.item = response.data;
            this.originalSlug = this.item.slug;
            if (this.item.slug.indexOf('new-blog') > -1) this.isNewlycreatedblog = true;
        });
    },
    methods: {
      isStatus(s) {
          if (!this.item.status) return false;
          return this.item.status.includes(s);
      },
      submit(evt) {
        evt.preventDefault()

        //const { email, password } = this
        var item = this.item
        item.updatedBy = this.name;

        console.log("item:",item)
        console.log("item._id:",item._id)
        console.log("item.title:",item.title)
        console.log("item.status:",item.status)


        Api().put(`/api/blogs/${item._id}`, item)
        .then(response => {
          this.$swal('Saved!', '', 'success');
          if (this.originalSlug != this.item.slug) this.$router.push({ name: 'admin-blogs' }); //if user changed slug
        })
        .catch((error) => {
          console.log("errorrrr:",error);
          const message = error.response.data.message;
          this.$swal('Oh oo!', `${message}`, 'error');
        });
      },
      cancel() {
          this.$router.push({ name: 'admin-blogs' });
          //this.$router.go(-1); // go back to previous page
      },
      sanitizeTitle: function(title) {
          var slug = "";
          // Change to lower case
          var titleLower = title.toLowerCase();
          // Letter "e"
          slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
          // Letter "a"
          slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
          // Letter "o"
          slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
          // Letter "u"
          slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
          // Letter "d"
          slug = slug.replace(/đ/gi, 'd');
          // Trim the last whitespace
          slug = slug.replace(/\s*$/g, '');
          // Change whitespace to "-"
          slug = slug.replace(/\s+/g, '-');
          return slug;
      }
      
    }
  }
</script>


<style>
.group-block {
    background-color: lightgrey;
    padding: 1em;
    border-bottom: 1px solid #999;
}
.group-block label {
    margin: auto 0.5em auto 0;
}

.datepicker {
    background-color: white;
    color: #363636;
    max-width: 100%;
    width: 100%;
    align-items: center;
    font-size: 1rem;
    height: 2.25em;
    -webkit-box-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/accounts/AdminBlog.vue